module.exports = __webpack_public_path__ + "img/level-3.8e3b41c7.png";